import '@/init/classComponentHooks';
import 'babel-polyfill';
import 'es6-promise/auto';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import * as uiv from 'uiv';
import Vue from 'vue';
import * as VueAuthImage from 'vue-auth-image';
import datePicker from 'vue-bootstrap-datetimepicker';
import App from './App.vue';
import msalBuilder from './init/msalSetup';
import router from './router';
import store from './store/store';

import './init/analyticsSetup';
import './init/initDirectives';
import './styles/build.scss';

Vue.config.productionTip = false;

Vue.use(uiv);
Vue.use(VueAuthImage);
Vue.use(datePicker);

// Wait for MSAL setup to complete before creating Vue app
msalBuilder().then(() => {
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
}).catch((error) => {
    // Still create the Vue app even if MSAL setup fails
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
});
